import Message from '@/views/Message/index.vue'

const MessageRouter = {
  path: '/message',
  name: 'Message',
  component: Message,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default MessageRouter
